module.exports = __webpack_public_path__ + "img/s1_t1_21.88c3ecd6.jpeg";